import { BaseEntityDTO, BranchYearDTO, IBaseEntityDTO, IBranchYearDTO, IUserDTO, UserDTO } from '.';

export interface IBranchDTO extends IBaseEntityDTO {
  name: string;
  city: string;
  state: string;
  website: string;
  instagram: string;
  facebook: string;
  twitter: string;
  bio: string;
  vimeo: string;
  youtube: string;
  branchYears: IBranchYearDTO[];
  users: IUserDTO[];
  branchLocation(): string;
}

export class BranchDTO extends BaseEntityDTO implements IBaseEntityDTO {
  name: string;
  city: string;
  state: string;
  website: string;
  instagram: string;
  facebook: string;
  twitter: string;
  bio: string;
  vimeo: string;
  youtube: string;
  users: IUserDTO[];
  branchYears: IBranchYearDTO[];

  constructor(data?: Partial<IBranchDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.name = data?.name ?? '';
    this.city = data?.city ?? '';
    this.state = data?.state ?? '';
    this.website = data?.website ?? '';
    this.instagram = data?.instagram ?? '';
    this.facebook = data?.facebook ?? '';
    this.twitter = data?.twitter ?? '';
    this.bio = data?.bio ?? '';
    this.vimeo = data?.vimeo ?? '';
    this.youtube = data?.youtube ?? '';
    this.branchYears = data?.branchYears
      ? data.branchYears.map((branchYear) => new BranchYearDTO(branchYear))
      : [];
    this.users = data?.users ? data.users.map((user) => new UserDTO(user)) : [];
  }

  branchLocation(): string {
    let seperator = '';
    if (this.state && this.city) {
      seperator = ', ';
    }
    return `${this.city}${seperator}${this.state}`;
  }
}
